import { useGame } from "../../../data/gameContext";

export default function Saloon() {
    const {updateGameState} = useGame();
    return (
        <div className="town-container">
            The Saloon
            <button onClick={() => updateGameState({Phase: 'townView'})}>Leave</button>
        </div>
    )
}